module.exports = __webpack_public_path__ + "54e0ed322359e10140e21caebcc8cce5.svg";